import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { getImageUrl } from '../../firebase/storageService';
import { uploadImagem } from '../../firebase/uploadImagem';
import { authFetch } from '../../utils/authFetch';
import DateInput from '../../components/DateInput';
import PageLoader from '../../components/PageLoader';

const EditarTerapeuta = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { showNotification } = useNotification();

    const [formData, setFormData] = useState(null);
    const [enabled, setEnabled] = useState(false); // Estado para o campo de status
    const [preview, setPreview] = useState(null);
    const fileInputRef = useRef(null);

    const niveisTerapeuta = {
        0: 'Gestora',
        1: 'Júnior',
        2: 'Estagiária',
        3: 'Sênior',
    };

    const formatarMoedaEmTempoReal = (valor) => {
        if (!valor) return '';
        const numeros = valor.replace(/\D/g, ''); // remove tudo que não for número

        const centavos = (parseInt(numeros, 10) / 100).toFixed(2); // divide por 100
        return centavos
            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    const formatarMoedaParaExibicao = (valor) => {
        if (valor == null || valor === '') return '';

        const numero = parseFloat(String(valor).replace(',', '.'));
        if (isNaN(numero)) return '';

        return numero
            .toFixed(2)
            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await authFetch(`therapist/${id}`, {
                });

                if (!res.ok) throw new Error();

                const data = await res.json();
                setFormData(data);
                setEnabled(data.disabled); // Definir o valor inicial do checkbox                
                setFormData({
                    ...data,
                    sessionFee: formatarMoedaParaExibicao(data.sessionFee),
                    extraFee: formatarMoedaParaExibicao(data.extraFee),
                });

                // Carrega imagem do Firebase
                const url = await getImageUrl('therapist', id);
                setPreview(url);
            } catch {
                showNotification('danger', 'Erro ao carregar terapeuta');
            }
        };

        fetchData();
    }, [id, showNotification]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'image' && files.length > 0) {
            const file = files[0];

            // Atualiza o estado com o arquivo
            setFormData((prev) => ({
                ...prev,
                image: file,
            }));

            // Atualiza o preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            // Para os outros campos
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const parseMoedaParaNumero = (valor) => {
        if (!valor) return 0;
        return parseFloat(valor.replace(/\./g, '').replace(',', '.'));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const imageFile = formData.image;
        let imageUrl = null;

        const level =
            formData.therapistLevel === undefined ||
                formData.therapistLevel === null ||
                formData.therapistLevel === ""
                ? 0
                : formData.therapistLevel;

        const payload = {
            ...formData,
            therapistLevel: level,
            sessionFee: parseMoedaParaNumero(formData.sessionFee),
            extraFee: parseMoedaParaNumero(formData.extraFee),
            disabled: enabled
        };

        // Upload da imagem no Firebase, se houver
        if (imageFile) {
            imageUrl = await uploadImagem(imageFile, 'therapist', id);
        }

        try {
            const response = await authFetch('therapist', {
                method: 'PUT',
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error();

            showNotification('success', 'Dados salvos com sucesso!');
            navigate(`/Terapeutas/PerfilTerapeuta/${id}`);
        } catch {
            showNotification('danger', 'Erro ao salvar terapeuta');
        }
    };

    if (!formData) return <PageLoader />;

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Editar</h4>
                            <br />
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="terapeutas form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <div className="row col-md-12">
                                        <div className="col-md-2">
                                            <div className="personal-image">
                                                <input
                                                    type="file"
                                                    name='image'
                                                    id='arquivo'
                                                    onChange={handleChange}
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                />
                                                <figure className="personal-figure">
                                                    <img
                                                        src={preview || require('../../assets/img/perfilvazio.png')}
                                                        alt="imagem-perfil"
                                                        className="personal-avatar"
                                                        onClick={() => fileInputRef.current.click()}
                                                        style={{ cursor: 'pointer', width: '100%' }}
                                                    />
                                                </figure>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-check form-switch">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="disabled"
                                            checked={enabled} onChange={(e) => setEnabled(e.target.checked)}
                                        />
                                        <label className="form-check-label">Desativado</label>
                                    </div>

                                    <div className="form-group">
                                        <label>Nome</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control form-control-sm"
                                            value={formData.name || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Apelido</label>
                                        <input
                                            type="text"
                                            name="nickname"
                                            className="form-control form-control-sm"
                                            value={formData.nickname || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Data de Nascimento</label>
                                        <DateInput
                                            name="birthdate"
                                            value={formData.birthdate || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Nível</label>
                                        <select
                                            name="therapistLevel"
                                            className="form-control form-control-sm"
                                            value={
                                                formData.therapistLevel === undefined ||
                                                    formData.therapistLevel === null ||
                                                    formData.therapistLevel === ""
                                                    ? 0
                                                    : formData.therapistLevel
                                            }
                                            onChange={handleChange}
                                        >
                                            {Object.entries(niveisTerapeuta).map(([valor, label]) => (
                                                <option key={valor} value={valor}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Data de Início Autin</label>
                                        <DateInput
                                            name="hiringDate"
                                            value={formData.hiringDate || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Valor Extra</label>
                                        <input
                                            type="text"
                                            name="extraFee"
                                            className="form-control form-control-sm"
                                            value={formData.extraFee || ''}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    extraFee: formatarMoedaEmTempoReal(e.target.value),
                                                }))
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Cor</label>
                                        <input
                                            type="color"
                                            name="color"
                                            className="form-control form-control-sm"
                                            value={formData.color || '#000000'}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Data Início das Férias</label>
                                        <DateInput
                                            name="vacationDate"
                                            value={formData.vacationDate || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Data Fim das Férias</label>
                                        <DateInput
                                            name="vacationEndDate"
                                            value={formData.vacationEndDate || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Valores</label>
                                        <input
                                            type="text"
                                            name="principles"
                                            className="form-control form-control-sm"
                                            value={formData.principles || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Apresentação</label>
                                        <textarea
                                            name="introduction"
                                            className="form-control form-control-sm"
                                            value={formData.introduction || ''}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="card-footer" style={{ paddingLeft: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-info btn-sm"
                                            onClick={() => navigate(`/Terapeutas/PerfilTerapeuta/${id}`)}
                                        >
                                            Cancelar
                                        </button>
                                        <button type="submit" className="btn btn-primary btn-sm mx-1">
                                            Salvar
                                        </button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditarTerapeuta;
